module.exports.MINUTES_15 = 1 / 96;
module.exports.MINUTES_30 = 1 / 48;
